
// Function to dynamically convert pattern to regex if it exists
export function buildValidation(validation) {
    if (!validation) return {};

    // If there's a pattern in the validation, convert the pattern value to a RegExp
    if (validation.pattern && validation.pattern.value) {
        return {
            ...validation,
            pattern: {
                value: new RegExp(validation.pattern.value), // Convert pattern string to RegExp
                message: validation.pattern.message,
            },
        };
    }

    // Return validation as is if no pattern needs to be converted
    return validation;
};

export function findResponse(responses, id) {
    const response = responses.find((r) => r.id === id);
    return response?.value || null;
}

// create a unique 16 char alphanumeric hash
export function createUniqueHash() {
    return Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
}